import { render, staticRenderFns } from "./MasterProposalPc.vue?vue&type=template&id=ad626856&scoped=true&"
import script from "./MasterProposalPc.vue?vue&type=script&lang=js&"
export * from "./MasterProposalPc.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposalPc.vue?vue&type=style&index=0&id=ad626856&prod&scoped=true&lang=scss&"
import style1 from "./MasterProposalPc.vue?vue&type=style&index=1&id=ad626856&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad626856",
  null
  
)

export default component.exports